export enum RealmEndpoints {
    REALMS = '/realms',
}
